import type { SocialPostType } from "../../../../types/models/campaign.models.types";
import type { IProposal } from "../../../../types/models/proposals.modals.types";
import type {
  SocialCreatorType,
  SocialPlatforms,
} from "../../../../types/models/social.models.types";
import { usePostHttp } from "../../http.hook";

interface IBody {
  brand: string;
  name: string;
  brief: string;
  socialPlatform: SocialPlatforms;
  socialPostType: SocialPostType;
  socialCreatorType: SocialCreatorType;
  expectedMetrics: {
    cost: number;
    views: number;
    posts: number;
  } | null;
  referenceCreators: Array<string> | [];
  notes?: string ;
}

interface IResponse {
  proposal: IProposal;
}

export function useCreateProposalAdminHttp() {
  return usePostHttp<IBody, IResponse>({
    path: "/admin/campaigns/proposals",
  });
}
